export const ROUTE_PARAMS = {
  RESTORE_GUID: 'restoreGuid',
  WAYBACK_GUID: 'waybackGuid',
  BANK_ALIAS: 'bankAlias',
  PRODUCT_ALIAS: 'productAlias',
  REGION_ALIAS: 'regionAlias',
  HASHED_DEAL_ID: 'hashedDealId',
} as const;
